/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_RescueInputs */

const en_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const ar_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إنقاذ`)
};

const bn_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const de_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const es_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const fr_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const pt_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const zh_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const tr_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const ru_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

const pl_svtag_rescue = /** @type {(inputs: Svtag_RescueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RESCUE`)
};

/**
* | output |
* | --- |
* | "#RESCUE" |
*
* @param {Svtag_RescueInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_rescue = /** @type {((inputs?: Svtag_RescueInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_RescueInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_rescue(inputs)
	if (locale === "bn") return bn_svtag_rescue(inputs)
	if (locale === "de") return de_svtag_rescue(inputs)
	if (locale === "es") return es_svtag_rescue(inputs)
	if (locale === "fr") return fr_svtag_rescue(inputs)
	if (locale === "pt") return pt_svtag_rescue(inputs)
	if (locale === "zh") return zh_svtag_rescue(inputs)
	if (locale === "tr") return tr_svtag_rescue(inputs)
	if (locale === "ru") return ru_svtag_rescue(inputs)
	if (locale === "pl") return pl_svtag_rescue(inputs)
	return en_svtag_rescue(inputs)
});